// extracted by mini-css-extract-plugin
export default {"outlined-char":"_5TZrR_outlined-char"};